<template>
	<div>
		<FrameAssemblyConfigurator v-model="frameAssemblyCreate" :frame-type.sync="frameType" @position-nr-validation="onPositionNrValidation"/>
		<div class="d-flex" :class="{'flex-column': sMobile}">
			<v-row class="grey lighten-4 pa-3 ma-0" :class="{'is-mobile': sMobile}">
				<v-col v-if="!sMobile" :cols="12" :md="6" class="d-flex flex-column"></v-col>
				<v-col :cols="12" :md="6">
					<v-row class="d-flex align-center justify-end" :class="{'flex-column': sMobile}">
						<v-col :cols="12" :md="4">
							<v-combobox v-model="frameAssemblyCreate.customerReference"
							            :label="$t('frameAssembly.customerReference')"
							            :placeholder="$t('frameAssembly.customerReference')"
							            :clearable="true"
							            :search-input.sync="search"
							            dense
							            hide-details
							            :items="customerReferences"
							            menu-props="closeOnContentClick"
							            @update:search-input="onCustomerReferenceInput"
							>
								<template v-slot:no-data>
									<v-list-item v-if="search != null" @click="handleNewCustomerReference(search)">
										<v-list-item-content>
											<v-list-item-title class="font-italic">
												{{ search }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
									<v-list-item v-else>
										<v-list-item-content>
											<v-list-item-title class="font-italic grey--text">
												{{ $t('cartPosition.terms.noCustomerReferenceInCart')  }}
											</v-list-item-title>
										</v-list-item-content>
									</v-list-item>
								</template>
							</v-combobox>
						</v-col>
						<v-col :cols="12" :md="5" v-if="numCarts > 1 && !sMobile">
							<CartSelectInput v-if="numCarts > 1" v-model="selectedCartId" :disabled="!hasPrices" simple/>
						</v-col>
						<v-col :cols="12" md="auto">
							<AsiBtn block :disabled="getAddButtonDisabled" :icon="icons.cart" color="primary" @click="addToCart()" large class="add-btn">
								{{ $t('cart.terms.addToCartDense') }}
							</AsiBtn>
						</v-col>
					</v-row>
				</v-col>
			</v-row>
		</div>
	</div>
</template>

<script lang="ts">
	import {Component, Prop} from 'vue-property-decorator';
	import CartSelectInput from "@/components/cart/shop/CartSelectInput.vue";
	import FrameAssemblyConfigurator from "@/components/frame-assembly/FrameAssemblyConfigurator.vue";
	import ItemPriceTable from "@/components/item/ItemPriceTable.vue";
	import AsiBtn from "@/components/common/AsiBtn.vue";
	import FrameAssemblyCreate from "@/models/frame-assembly/FrameAssemblyCreate";
	import Snackbar from "@/helpers/Snackbar";
	import {IItemShopListEntry} from "@/models/item/ItemShopModels";
	import {mixins} from "vue-class-component";
	import ResponsiveChecks from "@/mixins/ResponsiveChecks.vue";
	import Icon from "@/plugins/icons";
	import {FrameAssemblyType} from "@/helpers/constants";
	import AsiTextField from "@/components/common/AsiTextField";
	import AsiAutocomplete from "@/components/common/AsiAutocomplete";
	import AsiSelectSimple from "@/components/common/AsiSelectSimple";
	import UserUpdateDialogPersonalData from "@/components/user/UserUpdateDialogPersonalData.vue";

	@Component({
		components: {
			UserUpdateDialogPersonalData,
			AsiSelectSimple,
			AsiAutocomplete, AsiTextField, AsiBtn, ItemPriceTable, FrameAssemblyConfigurator, CartSelectInput}
	})
	export default class FrameAssemblyCreateDialog extends mixins(ResponsiveChecks) {

		private selectedCartId: string | null = null;
		private frameAssemblyCreate: FrameAssemblyCreate = new FrameAssemblyCreate();
		private showPriceTable: boolean = false;
		private frameType: FrameAssemblyType = FrameAssemblyType.cFrame;
		private isPositionNrValid: boolean = true;
		private search: string | null = null;

		private icons = Icon;

		public created(): void {
			this.selectedCartId = this.$store.state.cart.activeCartId;
		}

		@Prop({type: Object, required: true})
		public item!: IItemShopListEntry;

		private addToCart(): void {
			if (this.item !== null) {
				this.$store.dispatch('cart/addPosition', {
					item: this.item,
					frameAssembly: this.frameAssemblyCreate,
					quantity: this.frameAssemblyCreate.quantity,
					cartId: this.selectedCartId,
				})
					.then(() => this.$store.commit('cart/setExpanded', true))
					.catch(() => Snackbar.createError());
			}
		}

		private get hasPrices(): boolean {
			return (this.item?.prices.length ?? 0) > 0;
		}

		private get numCarts(): number {
			return this.$store.state.cart.carts.length;
		}

		private get customerReferences(): string[] | null {
			return this.$store.getters['cart/customerReferencesInActiveCart'];
		}

		private onCustomerReferenceInput(value: string | null): void {
			this.frameAssemblyCreate.customerReference = value;
		}

		private handleNewCustomerReference(value: string): void {
			this.frameAssemblyCreate.customerReference = value;
		}

		private onPositionNrValidation(isValid: boolean){
			this.isPositionNrValid = isValid;
		}

		private get getAddButtonDisabled(): boolean {
			return !this.isPositionNrValid || !this.hasPrices;
		}
	}
</script>

<style scoped lang="scss">

</style>
